import {
  TYPE_KAPHA,
  TYPE_PITTA,
  TYPE_VATA,
} from './types';

export default [
  {
    answers: [
      {
        label: 'Слаба',
        type: TYPE_VATA,
      },
      {
        label: 'Средна',
        type: TYPE_PITTA,
      },
      {
        label: 'Едра и широкоплещеста',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как най-добре бихте описали фигурата си?',
  },
  {
    answers: [
      {
        label: 'Леко, трудно напълнява',
        type: TYPE_VATA,
      },
      {
        label: 'Средно',
        type: TYPE_PITTA,
      },
      {
        label: 'Тежко със склонност към напълняване',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Какво е вашето телесно тегло?',
  },
  {
    answers: [
      {
        label: 'Крехки и скърцащи',
        type: TYPE_VATA,
      },
      {
        label: 'Нормални',
        type: TYPE_PITTA,
      },
      {
        label: 'Едри и здрави',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали ставите си?',
  },
  {
    answers: [
      {
        label: 'По-скоро сколиоза',
        type: TYPE_VATA,
      },
      {
        label: 'По-скоро кифоза',
        type: TYPE_PITTA,
      },
      {
        label: 'По-скоро лордоза',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Към каква форма на извивките си има тенденция гръбначният ви стълб?',
  },
  {
    answers: [
      {
        label: 'Тесни',
        type: TYPE_VATA,
      },
      {
        label: 'Средни',
        type: TYPE_PITTA,
      },
      {
        label: 'Широк',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали бедрата си?',
  },
  {
    answers: [
      {
        label: 'Плоскък',
        type: TYPE_VATA,
      },
      {
        label: 'Среден',
        type: TYPE_PITTA,
      },
      {
        label: 'Широк',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали гръдния си кош?',
  },
  {
    answers: [
      {
        label: 'Тънка',
        type: TYPE_VATA,
      },
      {
        label: 'Пропорционална',
        type: TYPE_PITTA,
      },
      {
        label: 'Широка',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали шията си?',
  },
  {
    answers: [
      {
        label: 'Слаба',
        type: TYPE_VATA,
      },
      {
        label: 'Атлетична и силна',
        type: TYPE_PITTA,
      },
      {
        label: 'Масивна и тежка',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали мускулатурата си?',
  },
  {
    answers: [
      {
        label: 'Студени',
        type: TYPE_VATA,
      },
      {
        label: 'Топли',
        type: TYPE_PITTA,
      },
      {
        label: 'Изпотени',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как са дланите и стъпалата ви?',
  },
  {
    answers: [
      {
        label: 'Суха със склонност към напукване',
        type: TYPE_VATA,
      },
      {
        label: 'Мазна със склонност към акне',
        type: TYPE_PITTA,
      },
      {
        label: 'Дебела и плътна',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали кожата си?',
  },
  {
    answers: [
      {
        label: 'Малки и неспокойни',
        type: TYPE_VATA,
      },
      {
        label: 'Пронизващи и лесно възпалими',
        type: TYPE_PITTA,
      },
      {
        label: 'Големи и спокойни',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали очите си?',
  },
  {
    answers: [
      {
        label: 'С неправилна форма',
        type: TYPE_VATA,
      },
      {
        label: 'Дълъг и заострен',
        type: TYPE_PITTA,
      },
      {
        label: 'Кръгъл и топчест',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали своя нос?',
  },
  {
    answers: [
      {
        label: 'Напукани и кафеникави',
        type: TYPE_VATA,
      },
      {
        label: 'Меки и червени',
        type: TYPE_PITTA,
      },
      {
        label: 'Сочни и бледи',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали устните си?',
  },
  {
    answers: [
      {
        label: 'Криви, зле оформени',
        type: TYPE_VATA,
      },
      {
        label: 'Средно големи, често кървящи венци',
        type: TYPE_PITTA,
      },
      {
        label: 'Големи, прави и бели',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали зъбите си?',
  },
  {
    answers: [
      {
        label: 'Суха, тъмна и чуплива',
        type: TYPE_VATA,
      },
      {
        label: 'Мазна, светла и руса',
        type: TYPE_PITTA,
      },
      {
        label: 'Плътна, гъста и лъскава',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали косата си?',
  },
  {
    answers: [
      {
        label: 'Крехки и чупливи',
        type: TYPE_VATA,
      },
      {
        label: 'Меки и розови',
        type: TYPE_PITTA,
      },
      {
        label: 'Дебели и здрави',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали вашите нокти?',
  },
  {
    answers: [
      {
        label: 'Непостоянен',
        type: TYPE_VATA,
      },
      {
        label: 'Добър, дори прекомерен',
        type: TYPE_PITTA,
      },
      {
        label: 'Умерен, но постоянен',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали апетита си?',
  },
  {
    answers: [
      {
        label: 'Слабо и образува газове',
        type: TYPE_VATA,
      },
      {
        label: 'Бързо, образува киселини и парене',
        type: TYPE_PITTA,
      },
      {
        label: 'Продължително, формира слуз',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали храносмилането си?',
  },
  {
    answers: [
      {
        label: 'Сладък, кисел, солен',
        type: TYPE_VATA,
      },
      {
        label: 'Сладък, стипчив, горчив',
        type: TYPE_PITTA,
      },
      {
        label: 'Стипчив, Лют, Горчив',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Какви вкусове предпочитате?',
  },
  {
    answers: [
      {
        label: 'Променлива',
        type: TYPE_VATA,
      },
      {
        label: 'Силна',
        type: TYPE_PITTA,
      },
      {
        label: 'Слаба',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Каква е нуждата ви за пиене на течности?',
  },
  {
    answers: [
      {
        label: 'Малки и сухи, с често изхождане',
        type: TYPE_VATA,
      },
      {
        label: 'Меки и кашави със склонност към диария',
        type: TYPE_PITTA,
      },
      {
        label: 'Редовно изхождане с мазни и твърди изпражнения',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали най-добре изпражненията си?',
  },
  {
    answers: [
      {
        label: 'Задух',
        type: TYPE_VATA,
      },
      {
        label: 'Възпаление',
        type: TYPE_PITTA,
      },
      {
        label: 'Слуз в носната кухина',
        type: TYPE_KAPHA,
      },
    ],
    question: 'От коя алергична реакция е по-вероятно да страдате?',
  },
  {
    answers: [
      {
        label: 'Хиперактивни - лесно се изтощават',
        type: TYPE_VATA,
      },
      {
        label: 'Умерени – добра издръжливост, фокус върху целта',
        type: TYPE_PITTA,
      },
      {
        label: 'Пасивни – силно издръжливи',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали своята физическа активност?',
  },
  {
    answers: [
      {
        label: 'Креативен, визионер',
        type: TYPE_VATA,
      },
      {
        label: 'Лидер',
        type: TYPE_PITTA,
      },
      {
        label: 'Обичащ да се грижи',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Кое от изброените по-долу би описало най-добре вашия тип личност?',
  },
  {
    answers: [
      {
        label: 'Колеблива, лесно се разсейва',
        type: TYPE_VATA,
      },
      {
        label: 'Съзтезателна-конкурентна',
        type: TYPE_PITTA,
      },
      {
        label: 'Спокойна и отдадена',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Каква е вашата умствена активност?',
  },
  {
    answers: [
      {
        label: 'Краткотрайна-лесно забравя',
        type: TYPE_VATA,
      },
      {
        label: 'Средна памет-добра концентрация',
        type: TYPE_PITTA,
      },
      {
        label: 'Много добра памет – трудно забравя',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали паметта си?',
  },
  {
    answers: [
      {
        label: 'Бърза и честа',
        type: TYPE_VATA,
      },
      {
        label: 'Умерена и убедителна',
        type: TYPE_PITTA,
      },
      {
        label: 'Бавна и спокойна',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали вашата реч?',
  },
  {
    answers: [
      {
        label: 'Лек',
        type: TYPE_VATA,
      },
      {
        label: 'Остър',
        type: TYPE_PITTA,
      },
      {
        label: 'Дебел и плътен',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали гласа си?',
  },
  {
    answers: [
      {
        label: 'Бързо, плитко, променливо',
        type: TYPE_VATA,
      },
      {
        label: 'Импулсивно, отчетливо, редовно',
        type: TYPE_PITTA,
      },
      {
        label: 'Дълбоко, бавно и устойчиво',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Какво е вашето дишане?',
  },
  {
    answers: [
      {
        label: 'Неувереност и нерешителност',
        type: TYPE_VATA,
      },
      {
        label: 'Раздразнение и избухливост',
        type: TYPE_PITTA,
      },
      {
        label: 'Упоритост и сдържаност',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Какво поведение преобладава във вас?',
  },
  {
    answers: [
      {
        label: 'Бърза',
        type: TYPE_VATA,
      },
      {
        label: 'Умерена',
        type: TYPE_PITTA,
      },
      {
        label: 'Бавна',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Каква е вашата походка?',
  },
  {
    answers: [
      {
        label: 'Жертва – страх',
        type: TYPE_VATA,
      },
      {
        label: 'Агресия – смелост',
        type: TYPE_PITTA,
      },
      {
        label: 'Наблюдаване – безразличие',
        type: TYPE_KAPHA,
      },
    ],
    question: 'С коя от изброените по-долу емоции се идентифицирате най-добре?',
  },
  {
    answers: [
      {
        label: 'Лек – често се буди',
        type: TYPE_VATA,
      },
      {
        label: 'Кратък и лесен',
        type: TYPE_PITTA,
      },
      {
        label: 'Дълбок, трудно се буди',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Как бихте описали съня си? ',
  },
  {
    answers: [
      {
        label: 'Летене-реене',
        type: TYPE_VATA,
      },
      {
        label: 'Битка',
        type: TYPE_PITTA,
      },
      {
        label: 'Романтични сънища',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Какви са вашите сънища, какво сънувате?',
  },
  {
    answers: [
      {
        label: 'Музика, изкуство, четене',
        type: TYPE_VATA,
      },
      {
        label: 'Спорт, политика, образование',
        type: TYPE_PITTA,
      },
      {
        label: 'Почивка, храна, приятели',
        type: TYPE_KAPHA,
      },
    ],
    question: 'Какви са вашите хобита?',
  },
];
